import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modalWindow', 'submitButton', 'loadingButton']
  static values = { submitted: Boolean } // フォーム送信済みかを管理

  modalShow(event) {
    event.preventDefault()
    this.modalWindowTarget.classList.remove('hidden')
  }

  modalHidden(event) {
    event.preventDefault()
    this.modalWindowTarget.classList.add('hidden')
  }

  modalSubmit(event) {
    event.preventDefault()

    if (this.submittedValue) return

    this.submittedValue = true

    this.submitButtonTarget.classList.add('hidden')
    this.loadingButtonTarget.classList.remove('hidden')
    this.loadingButtonTarget.classList.add('inline-block')

    this.element.closest('form').submit()
  }
}
